import React from "react";
import { Form } from "react-bootstrap";

const CustomSelect = ({
  label = "",
  options = [],
  value,
  onChange,
  name = "",
  placeholder = "Select",
  className = "",
  style = {},
  showColorCircle = false, 
  ...rest
}) => {
  const handleChange = (e) => {
    const selectedVal = e.target.value;
    const selectedOption = options.find((opt) => opt.value === selectedVal);
    onChange(selectedOption); // Pass full object
  };

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <Form.Group className={`mb-1 ${className}`}>
      {label && <Form.Label>{label}</Form.Label>}

      <div className="d-flex align-items-center gap-2">
        {/* The select box */}
        <Form.Select
          value={value}
          onChange={handleChange}
          name={name}
          {...rest}
          style={{ flex: 1, ...style }}
        >
          <option value="">{placeholder}</option>
          {options.map((opt, idx) => (
            <option key={idx} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Form.Select>

        {/*  Show color circle only when applicable */}
        {showColorCircle && selectedOption?.color && (
          <span
            style={{
              width: 22,
              height: 22,
              borderRadius: "50%",
              backgroundColor: selectedOption.color,
              border: "1px solid #ccc",
              display: "inline-block",
            }}
          ></span>
        )}
      </div>
    </Form.Group>
  );
};

export default CustomSelect;
